export const navbar = 1000
export const overlay = 2000
export const modal = 3000
export const tooltip = 4000
